<template>
  <FilesList ></FilesList>
</template>

<script>
import FilesList from "@/views/components/Library/FilesList.vue";

export default {
  name: 'FilesListPage',
  components: {FilesList}

}
</script>
<style scoped>
.files-page >>> .card-body {
  padding: 1.5rem;
}
.toolbar-card {
  border-radius: 18px;
  border: 1px solid #e2e8f0;
}
</style>
